import {Column, Entity, OneToMany, PrimaryColumn} from "typeorm";
import {Navigation} from "./Navigation";
import {Exclude} from "class-transformer";

@Entity()
export class User {
  @PrimaryColumn({type: "varchar"})
  ID: string;

  @Column({nullable: true, type: "varchar"})
  email: string | null;

  @Column({nullable: true, type: "varchar"})
  name: string | null;

  @Column({type: "bigint", nullable: true})
  firstLogin: string | null;

  @Column({nullable: true, type: "varchar"})
  firstLoginFull: string | null;

  @Column({default: true, type: "varchar"})
  isFree: string;

  @Column({type: "bigint", nullable: true})
  subscriptionExpDate: string | null;

  @Column({nullable: true, type: "varchar"})
  subscriptionExpDateFull: string | null;

  @Column({type: "bigint", nullable: true})
  lmd: string | null;

  @Column({nullable: true, type: "varchar"})
  lmdFull: string | null;

  @Column({type: "bigint", nullable: true})
  dateOfBirth: string | null;

  @Column({nullable: true, type: "varchar"})
  country: string | null;

  @Column({nullable: true, type: "varchar"})
  weight: string | null;

  @Column({nullable: true, type: "varchar"})
  height: string | null;

  @Column({type: "simple-json", nullable: true})
  sports: any;

  @Column({nullable: true, type: "boolean"})
  marketing: boolean | null;

  @Column({nullable: true, type: "varchar"})
  gender: string | null;

  @Column({nullable: true, name: "Adapty-ID", type: "varchar"})
  "Adapty-ID": string | null;

  @Column({nullable: true, name: "GF-InstallationID", type: "varchar"})
  "GF-InstallationID": string | null;

  @Column({nullable: true, name: "GF-SubscriberID", type: "varchar"})
  "GF-SubscriberID": string | null;

  @Column({nullable: true, name: "IAFCode", type: "varchar"})
  IAFCode: string | null;

  @Column({nullable: true, name: "IAFleft", type: "varchar"})
  IAFleft: string | null;

  @Column({type: "int", nullable: true, name: "Stats-Activities"})
  "Stats-Activities": number | null;

  @Column({type: "float", nullable: true, name: "Stats-Dis"})
  "Stats-Dis": number | null;

  @Column({nullable: true, name: "Stats-Dur", type: "varchar"})
  "Stats-Dur": string | null;

  @Column({nullable: true, name: "Stats-Dur-MS", type: "bigint"})
  "Stats-Dur-MS": string | null;

  @Column({type: "float", nullable: true, name: "Stats-Maxspeed"})
  "Stats-Maxspeed": number | null;

  @Column({nullable: true, name: "activeCampaignId", type: "varchar"})
  activeCampaignId: string | null;

  @Column({nullable: true, name: "appVer", type: "varchar"})
  appVer: string | null;

  @Column({nullable: true, name: "appVersion", type: "varchar"})
  appVersion: string | null;

  @Column({nullable: true, name: "appleUserID", type: "varchar"})
  appleUserID: string | null;

  @Column({nullable: true, name: "fcmToken", type: "varchar"})
  fcmToken: string | null;

  @Column({nullable: true, name: "featuresVersion", type: "varchar"})
  featuresVersion: string | null;

  @Column({type: "bigint", nullable: true, name: "firstPurchase"})
  firstPurchase: string | null;

  @Column({nullable: true, name: "firstPurchaseFull", type: "varchar"})
  firstPurchaseFull: string | null;

  @Column({nullable: true, name: "gAppVersion", type: "varchar"})
  gAppVersion: string | null;

  @Column({nullable: true, name: "gBuild", type: "varchar"})
  gBuild: string | null;

  @Column({nullable: true, name: "iCloudID", type: "varchar"})
  iCloudID: string | null;

  @Column({nullable: true, name: "idfa", type: "varchar"})
  idfa: string | null;

  @Column({nullable: true, name: "img", type: "varchar"})
  img: string | null;

  @Column({nullable: true, name: "isFeaturesSeen", type: "boolean"})
  isFeaturesSeen: boolean | null;

  @Column({nullable: true, name: "lang", type: "varchar"})
  lang: string | null;

  @Column({type: "bigint", nullable: true, name: "lastLoginAndroid"})
  lastLoginAndroid: string | null;

  @Column({type: "bigint", nullable: true, name: "lastLoginWeb"})
  lastLoginWeb: string | null;

  @Column({nullable: true, name: "loginType", type: "varchar"})
  loginType: string | null;

  @Column({type: "bigint", nullable: true, name: "lud"})
  lud: string | null;

  @Column({nullable: true, name: "ludFormatted", type: "varchar"})
  ludFormatted: string | null;

  @Column({nullable: true, name: "ludFull", type: "varchar"})
  ludFull: string | null;

  @Column({type: "simple-json", nullable: true, name: "notifications"})
  notifications: any;

  @Column({nullable: true, name: "sandboxUser", type: "boolean"})
  sandboxUser: boolean | null;

  @Column({nullable: true, name: "source", type: "varchar"})
  source: string | null;

  @Column({nullable: true, name: "sourceDate", type: "varchar"})
  sourceDate: string | null;

  @Column({nullable: true, name: "sourceDateMS", type: "bigint"})
  sourceDateMS: string | null;

  @Column({nullable: true, name: "statsDurationFull", type: "varchar"})
  statsDurationFull: string | null;

  @Column({nullable: true, name: "status", type: "boolean"})
  status: boolean | null;

  @Column({nullable: true, name: "subscriptionStatus", type: "int"})
  subscriptionStatus: number | null;

  @Column({nullable: true, name: "subscriptionType", type: "varchar"})
  subscriptionType: string | null;

  @Column({type: "simple-json", nullable: true, name: "subscription"})
  subscription: any;

  @Column({nullable: true, name: "token", type: "varchar"})
  token: string | null;

  @Column({type: "simple-json", nullable: true, name: "entitlement"})
  entitlement: any;

  @Exclude()
  @OneToMany(() => Navigation, (navigation) => navigation.user, {cascade: false})
  navigations: Navigation[];
}
